import * as yup from 'yup'

export const insurancePolicyFormValidator = yup.object({
  // `AdminInsurancePolicyCreateDto` and `…UpdateDto` both mark `name` `@IsNotEmpty @IsString`
  // and trim it server-side. Trimming here too means the stored value matches what was typed.
  name: yup.string().trim().required('Policy name is required'),
})
